import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";

import { getAllStaff } from "../api/staffApi";
import { getAllStaffForStaff } from "../api/staffPortalApi";

import StaffTable from "../components/StaffTable";
import { useStaffAuth } from "../context/StaffAuthContext";
import { Button, Card } from "../components/ui";

const StaffList = ({ isPortal = false }) => {
  const { hasPermission } = useStaffAuth();

  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadStaff = async () => {
    try {
      const data = isPortal
        ? await getAllStaffForStaff()
        : await getAllStaff();

      setStaff(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStaff();
  }, []);

  const createStaffUrl = isPortal ? "/staff-panel/staff/create" : "/staff/create";
  const canAddStaff = isPortal ? hasPermission("STAFF_MANAGEMENT_FULL") : true;

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto space-y-6 min-h-screen">
      {/* Page Title & Actions */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl sm:text-xl sm:text-2xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">
            Staff Management
          </h1>
          <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
            Manage, view, and assign staff roles across your institution
          </p>
        </div>

        {canAddStaff && (
          <Link to={createStaffUrl}>
            <Button leftIcon={<UserPlus className="h-4 w-4" />}>
              Add Staff Member
            </Button>
          </Link>
        )}
      </div>

      {/* Directory Content */}
      {loading ? (
        <Card className="p-12 text-center text-sm text-neutral-500 dark:text-neutral-400">
          Loading staff directory...
        </Card>
      ) : staff.length === 0 ? (
        <Card className="p-12 text-center text-sm text-neutral-500 dark:text-neutral-400">
          No staff records found.
        </Card>
      ) : (
        <StaffTable
          staff={staff}
          refreshStaff={loadStaff}
          isPortal={isPortal}
        />
      )}
    </div>
  );
};

export default StaffList;
